import React from 'react';

const ToggleSwitch = ({ label, checked, onChange, icon, color = 'blue' }) => {
  const colorClasses = {
    blue: 'bg-blue-600',
    red: 'bg-red-600', 
    yellow: 'bg-yellow-500',
    green: 'bg-green-600',
    orange: 'bg-orange-500'
  };

  return (
    <div className="flex items-center space-x-3">
      <button
        onClick={() => onChange(!checked)}
        className={`
          relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${color}-500
          ${checked ? colorClasses[color] : 'bg-gray-200'}
        `}
      >
        <span
          className={`
            inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200
            ${checked ? 'translate-x-6' : 'translate-x-1'}
          `}
        />
      </button>
      
      <div className="flex items-center space-x-2">
        {icon && <span className="text-lg">{icon}</span>}
        <span className={`text-sm font-medium ${checked ? 'text-gray-900' : 'text-gray-600'}`}>
          {label}
        </span>
      </div>
    </div>
  );
};

export default ToggleSwitch;